<template>
  <div>
    <div class="page_background category_bg home_bg" />
    <Breadcrumbs :breaditems="breaditems" />
    <section class="cards">
      <div class="container">
        <div class="cards_wrap">
          <div class="section_top">
            <h1 v-text="pageH1" />
          </div>
          <BlogTabs />
          <div class="cards_content">
            <div class="cards_content_item page_content_item active">
              <div class="cards_list_wrap">
                <div class="cards_list">
                  <!--news_item-->
                  <BlogItem v-for="item in posts" :key="item.index" :post="item" />
                  <!--news_item-->
                </div>
                <!--pagination-->
                <Pagination :pagiitems="pagiitems" />
                <!--pagination-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <render-on-scroll :offset-y="100">
      <CarouselProducts :ext="{ product_type: 'newest', title: $t('product.latest_products'), type: 'products', id: 'novelty', class: 'category_widget' }" />
    </render-on-scroll>
  </div>
</template>
<script>
import CarouselProducts from '../../../components/modules/CarouselProducts'
import BlogTabs from '../../../components/menu/BlogTabs'
import BlogItem from '../../../components/blog/BlogItem'
import Breadcrumbs from '../../../components/Breadcrumbs'
import Pagination from '../../../components/Pagination'

export default {
  components: {
    CarouselProducts,
    BlogTabs,
    BlogItem,
    Breadcrumbs,
    Pagination
  },
  transition: {
    name: 'intro',
    afterLeave (el) {
      this.$nuxt.$emit('mm_hide')
    }
  },
  async asyncData ({ app, query, params, error }) {
    try {
      const category = await app.$axios.$get(`/api/promo/categories/${params.slug}/`)
      const [posts] = await Promise.all([
        app.$axios.$get('/api/promo/posts/', { params: { page: query.page, category_id: category.data.id } })
      ])
      return {
        posts: posts.data,
        seo: posts.seo_template,
        category: category.data,
        pagination: posts.meta
      }
    } catch (err) {
      return error({
        statusCode: err.response ? err.response.status : 422,
        message: err.message
      })
    }
  },
  data () {
    return {
      debug: '',
      loading: false,
      posts: [],
      seo: null,
      pagination: null,
      category: {}
    }
  },
  head () {
    const i18nHead = this.$formatSeoTags(
      this.$nuxtI18nHead({ addSeoAttributes: { canonicalQueries: ['page'] } }),
      this.pageIndex,
      this.pageCanonical
    )
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      title: this.pageMetaTitle,
      meta: [
        { hid: 'description', name: 'description', content: this.pageMetaDescription },
        { hid: 'keywords', name: 'keywords', content: this.pageMetaKeywords },
        { hid: 'og_locale', property: 'og:locale', content: this.$i18n.locale },
        { hid: 'og_title', property: 'og:title', content: this.pageMetaTitle },
        { hid: 'og_description', property: 'og:description', content: this.pageMetaDescription },
        { hid: 'og_url', property: 'og:url', content: process.env.API_URL_BROWSER + this.$nuxt.$route.fullPath },
        { hid: 'og_image', property: 'og:image', content: this.$options.filters.mediaUrl(this.category, 'avatar', 'url') },
        { hid: 'twitter_card', property: 'twitter:card', content: 'summary' },
        { hid: 'twitter_title', property: 'twitter:title', content: this.pageMetaTitle },
        { hid: 'twitter_description', property: 'twitter:description', content: this.pageMetaDescription },
        { hid: 'twitter_image', property: 'twitter:image', content: process.env.API_URL_BROWSER + '/icons/logo.svg' },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    breaditems () {
      return [
        {
          to: 'index',
          exact: true,
          text: this.$i18n.t('breadcrumbs.home'),
          alt: this.$i18n.t('breadcrumbs.home_in_breadcrumbs')
        },
        {
          to: 'blog',
          text: this.$i18n.t('blog.title')
        },
        {
          to: this.localePath({ name: 'blog-category-slug', params: { slug: this.category.slug } }),
          disable: true,
          text: this.category.title
        }
      ]
    },
    pagiitems () {
      return this.pagination
    },
    paginationText () {
      return this.pagination.current_page > 1 ? ` - ${this.$i18n.t('catalog.page_current')} ${this.pagination.current_page}/${this.pagination.last_page}` : ''
    },
    pageMetaTitle () {
      return (this.category.meta_title ?? this.seo.title ?? this.category.title ?? this.$i18n.t('catalog.title')) + this.paginationText
    },
    pageMetaDescription () {
      return (this.category.meta_description ?? this.seo.description ?? this.category.title ?? this.$i18n.t('catalog.title')) + this.paginationText
    },
    pageMetaKeywords () {
      return this.category.meta_keywords ?? ''
    },
    pageH1 () {
      return (this.category.meta_h1 ?? this.seo.h1 ?? this.category.title ?? this.$i18n.t('catalog.title')) + this.paginationText
    },
    pageCanonical () {
      return (this.category.indexing_status === 'enabled') ? (this.category.canonical ? this.category.canonical : (process.env.API_URL_BROWSER + this.localePath({ name: 'blog-category-slug', params: { slug: this.category.slug } }) + '/')) : null
    },
    pageIndex () {
      return (this.category.indexing_status === 'enabled') ? 'enabled' : 'disabled'
    }
  },
  mounted () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
}
</script>
